'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const SidebarNavListView = require('./nav');
const SidebarItemCollection = require('./collection');
const Template = require('common/ui/template/sidebar/index.hbs');
const ContentTemplate = require('common/ui/template/sidebar/content.hbs');
const DefaultHeaderTemplate = require('common/ui/template/sidebar/header.hbs');

const DefaultHeaderView = Mn.View.extend({
    template: DefaultHeaderTemplate,
    templateContext: function() {
        return {
            title: this.getOption('title')
        }
    }
});

const ContentView = Mn.View.extend({
    id: 'sidebar-content',
    className: 'sidebar-content',
    template: ContentTemplate,
    regions: {
        contentHeader: '.sidebar-content-header-wrapper',
        contentBody: '.sidebar-content-body'
    },

    templateContext: function() {
        return {
            header: this.getOption('header')
        }
    },

    onRender: function() {
        const header = this.getOption('header');
        if(header) {
            this.showChildView('contentHeader', new DefaultHeaderView({
                model: this.model,
                title: header
            }));
        }
        this.showChildView('contentBody', this.getOption('view'));
    }
});

module.exports = Mn.View.extend({
    className: 'row sidebar',
    template: Template,
    ui: {
        drag: '#sidebar-drag'
    },
    events: {
        'click .sidebar-nav-wrapper': 'forceClose',
        'mousedown @ui.drag': 'startResize'
    },
    regions: {
        nav: '.sidebar-nav',
        contentWrapper: '.sidebar-content-wrapper'
    },
    width: 428,
    horizontalNav: false,

    initialize: function() {
        _.bindAll(this, 'resize', 'endResize');
        this._navs = this.getOption('navs');
        this._active = null;
        this._width = 0;
        this._openWidth = this.getOption('width');
        if($(window).width() < 768) {
            this._openWidth = $(window).width();
        }
        $(window).resize(() => {
            if($(window).width() < 768 + 44) {
                this._openWidth = $(window).width() - 44;
                this._width = this._openWidth;
                if(this.$el.hasClass('is-shown')) {
                    this.$el.width(this._width);
                }
            }
        });
        this._ondrag = false;
        this._startX = 0;
    },

    templateContext: function() {
        return {
            horizontalNav: this.getOption('horizontalNav')
        }
    },

    onRender: function() {
        if(!this.getOption('horizontalNav')) {
            this._navs = new SidebarItemCollection(this._navs);
            const navListView = new SidebarNavListView({
                collection: this._navs
            });
            this.showChildView('nav', navListView);
        }

        const open = this._navs.find(nav => nav.get('open'));
        if(open && $(window).width() > 767) {
            open.activate();
            this.openNoAnimation();
            this._active = open;
            this.showChildView('contentWrapper', new ContentView({
                model: this.model,
                header: open.getHeader(),
                view: open.getView()
            }));
        }

        this.listenTo(this._navs, 'active', this.onActivate);
        this.listenTo(this._navs, 'inactive', this.onDeactivate);
        this.$('[data-toggle="tooltip"]').tooltip();
    },

    activate: function(name) {
        const nav = this._navs.findWhere({name: name});
        if(nav) {
            nav.activate();
        }
    },

    getView(name) {
        const nav = this._navs.findWhere({name: name});
        return nav && nav.getView();
    },

    onActivate: function(nav) {
        if(pre && pre == this._activate) {
            return;
        }
        this.open();
        const pre = this._active;
        this._active = nav;
        this.getRegion('contentWrapper').detachView();
        this.showChildView('contentWrapper', new ContentView({
            model: this.model,
            header: nav.getHeader(),
            view: nav.getView()
        }));
        if(pre){
            pre.deactivate();
        }
    },

    onDeactivate: function(nav) {
        if(this._active == nav) {
            this._active = null;
            this.close();
        }
    },

    open: function() {
        this.$el.addClass('is-shown');
        this._width = this._openWidth;
        this.$el.animate({
            width: this._width
        }, 200).css('overflow', 'visible');
    },

    openNoAnimation: function() {
        this.$el.addClass('is-shown');
        this._width = this._openWidth;
        this.$el.css({
            'width': this._width,
            'overflow': 'visible'
        });
    },

    close: function() {
        this.$el.removeClass('is-shown');
        this._width = 0;
        this.$el.animate({
            width: this._width
        }, 200).css('overflow', 'visible');
    },

    forceClose: function() {
        if(this._active) {
            this._active.deactivate();
        } else {
            this.close();
        }
    },

    startResize: function(e) {
        this._ondrag = true;
        this._startX = e.clientX;

        $(window).on('mousemove', this.resize);
        $(window).on('mouseup', this.endResize);
    },

    resize: function(e) {
        e.preventDefault();
        if(this._ondrag) {
            const dX = this._startX - e.clientX;
            this._startX = e.clientX;
            this._width += dX;

            if(this._width < 0) {
                this._width = 0;
            }
            this._openWidth = this._width;
            if(this._width < 16) {
                this._openWidth = 428;
            }

            this.$el.css('width', this._width);
        }
    },

    endResize: function() {
        this._ondrag = false;
        $(window).off('mousemove', this.resize);
        $(window).off('mouseup', this.endResize);
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/sidebar/index.js